import { useEffect, useState } from 'react';
import cx from 'classnames';
import { MDText } from 'i18n-react';

import { PriceTagIcon } from '@motorway/mw-highway-code';
import { InfoBox } from '@motorway/mw-highway-code/alpha';

import { getValueFromLocalStorage, setValueInLocalStorage } from 'Utilities/helpers/localStorage.helpers';

import texts from './PromotionsBanner.texts';
import { useDiscountValues } from './useDiscountValues';

import styles from './PromotionsBanner.module.scss';

const LocalT = new MDText(texts);

const LOCAL_STORAGE_KEY = 'mobilePromotionsBanner';

// eslint-disable-next-line local-rules/variable-naming
const PriceTagIconNotFilled = () => <PriceTagIcon filled={false} />;

export const PromotionsBannerMobile: React.FC<{ containerClassName?: string; onClose: () => void }> = ({
	containerClassName,
	onClose,
}) => {
	const [hasClosedBanner, setHasClosedBanner] = useState(false);
	const discountValues = useDiscountValues();

	useEffect(() => {
		setHasClosedBanner(getValueFromLocalStorage(LOCAL_STORAGE_KEY) === 'true');
	}, []);

	if (!discountValues || hasClosedBanner) {
		return null;
	}

	return (
		<div
			className={cx([
				styles.mobileContainer,
				styles.hideOnDesktop,
				// Required to prevent flicker
				'promotions-banner-dismissable',
				containerClassName,
			])}
		>
			<InfoBox
				content={
					<div>
						{LocalT.translate(texts.description, {
							percentageDiscount: discountValues.percentageDiscount,
							purchaseThreshold: discountValues.purchaseThreshold,
						})}
					</div>
				}
				heading={LocalT.translate(texts.title, { percentageDiscount: discountValues.percentageDiscount })}
				icon={PriceTagIconNotFilled}
				onClose={() => {
					setValueInLocalStorage({ id: LOCAL_STORAGE_KEY, value: 'true' });
					setHasClosedBanner(true);
					onClose?.();
				}}
			/>
		</div>
	);
};
